
import Vue from "vue";
import * as echarts from "echarts";
import axios from "axios";
import API from "../service/config";
import { post, fetch, patch, put, toDelete } from "../service/http-service";
import { Loading } from "element-ui";

export default Vue.extend({
  name: "Echart2",
  props: ["tableData"],
  data() {
    return {
      pDataData: [
        {
          dataset_id: "LSE101102",
          p_val_adj: 0.2458,
          avg_log2_fc: -0.4206,
          cellname: "Neuroendocrine cell",
          gene: "TGFB2",
        },
        {
          dataset_id: "LSE101102",
          p_val_adj: 2.7694e-31,
          avg_log2_fc: -0.3501,
          cellname: "Ciliated cell",
          gene: "TGFB2",
        },
        {
          dataset_id: "LSE101102",
          p_val_adj: 1,
          avg_log2_fc: -0.3231,
          cellname: "Ciliated cell",
          gene: "TGFB2",
        },
        {
          dataset_id: "LSE100106",
          p_val_adj: 7.222e-251,
          avg_log2_fc: 0.7787,
          cellname: "Epithelial cell",
          gene: "TGFB2",
        },
        {
          dataset_id: "LSE100106",
          p_val_adj: 0.0043,
          avg_log2_fc: -0.5714,
          cellname: "Secretory cell",
          gene: "TGFB2",
        },
        {
          dataset_id: "LSE100106",
          p_val_adj: 1,
          avg_log2_fc: -0.5664,
          cellname: "Ciliated cell",
          gene: "TGFB2",
        },
        {
          dataset_id: "LSE100106",
          p_val_adj: 1.7203e-38,
          avg_log2_fc: -0.5537,
          cellname: "Ciliated cell",
          gene: "TGFB2",
        },
        {
          dataset_id: "LSE100106",
          p_val_adj: 1.0676e-14,
          avg_log2_fc: -0.5436,
          cellname: "Erythrocyte",
          gene: "TGFB2",
        },
        {
          dataset_id: "LSE100106",
          p_val_adj: 1.9237e-22,
          avg_log2_fc: -0.5392,
          cellname: "Secretory cell",
          gene: "TGFB2",
        },
        {
          dataset_id: "LSE100106",
          p_val_adj: 0.0011,
          avg_log2_fc: -0.501,
          cellname: "Ciliated cell",
          gene: "TGFB2",
        },
        {
          dataset_id: "LSE100106",
          p_val_adj: 3.0914e-57,
          avg_log2_fc: 0.3885,
          cellname: "Airway smooth muscle cell",
          gene: "TGFB2",
        },
        {
          dataset_id: "LSE100106",
          p_val_adj: 2.5491e-12,
          avg_log2_fc: -0.3869,
          cellname: "Secretory cell",
          gene: "TGFB2",
        },
        {
          dataset_id: "LSE100106",
          p_val_adj: 1,
          avg_log2_fc: -0.384,
          cellname: "Neuroendocrine cell",
          gene: "TGFB2",
        },
        {
          dataset_id: "LSE100106",
          p_val_adj: 3.3431e-33,
          avg_log2_fc: 0.3186,
          cellname: "Epithelial cell",
          gene: "TGFB2",
        },
        {
          dataset_id: "LSE100106",
          p_val_adj: 1,
          avg_log2_fc: -0.2653,
          cellname: "Submucosal gland",
          gene: "TGFB2",
        },
        {
          dataset_id: "LSE100108",
          p_val_adj: 3.7193e-47,
          avg_log2_fc: -0.2829,
          cellname: "Ciliated cell",
          gene: "TGFB2",
        },
        {
          dataset_id: "LSE100108",
          p_val_adj: 0,
          avg_log2_fc: 0.2555,
          cellname: "Secretory cell",
          gene: "TGFB2",
        },
        {
          dataset_id: "LSE100108",
          p_val_adj: 7.1282e-162,
          avg_log2_fc: 0.2528,
          cellname: "Basal cell",
          gene: "TGFB2",
        },
        {
          dataset_id: "LSE100111",
          p_val_adj: 1.87e-111,
          avg_log2_fc: 0.2629,
          cellname: "Lymphatic endothelial cell",
          gene: "TGFB2",
        },
        {
          dataset_id: "LSE100112",
          p_val_adj: 2.0104e-49,
          avg_log2_fc: 0.5896,
          cellname: "Pericyte",
          gene: "TGFB2",
        },
        {
          dataset_id: "LSE100112",
          p_val_adj: 3.6219e-16,
          avg_log2_fc: 0.4464,
          cellname: "Vascular associated smooth muscle cell",
          gene: "TGFB2",
        },
        {
          dataset_id: "LSE100112",
          p_val_adj: 3.0772e-27,
          avg_log2_fc: 0.3632,
          cellname: "Myofibroblast",
          gene: "TGFB2",
        },
        {
          dataset_id: "LSE101112",
          p_val_adj: 2.0244e-17,
          avg_log2_fc: 0.7516,
          cellname: "Pericyte",
          gene: "TGFB2",
        },
        {
          dataset_id: "LSE101112",
          p_val_adj: 1.2677e-6,
          avg_log2_fc: 0.7396,
          cellname: "Pericyte",
          gene: "TGFB2",
        },
        {
          dataset_id: "LSE101112",
          p_val_adj: 7.8998e-8,
          avg_log2_fc: 0.3907,
          cellname: "Pericyte",
          gene: "TGFB2",
        },
        {
          dataset_id: "LSE100114",
          p_val_adj: 5.9353e-28,
          avg_log2_fc: 0.3021,
          cellname: "Dendritic cell",
          gene: "TGFB2",
        },
      ],
    };
  },
  mounted() {
  this.initEchart();
  },
  methods: {
    initEchart() {
  // 获取DOM元素
const chartContainer = this.$refs.chartContainer as HTMLElement;

// 初始化ECharts实例
const myChart = echarts.init(chartContainer);

// 准备数据
const datas = [
  {
    dataset_id: "LSE101102",
    p_val_adj: 0.2458,
    avg_log2_fc: -0.4206,
    cellname: "Neuroendocrine cell",
    gene: "TGFB2",
  },
  {
    dataset_id: "LSE101102",
    p_val_adj: 2.7694e-31,
    avg_log2_fc: -0.3501,
    cellname: "Ciliated cell",
    gene: "TGFB2",
  },
  {
    dataset_id: "LSE101102",
    p_val_adj: 1,
    avg_log2_fc: -0.3231,
    cellname: "Ciliated cell",
    gene: "TGFB2",
  },
  {
    dataset_id: "LSE100106",
    p_val_adj: 7.222e-251,
    avg_log2_fc: 0.7787,
    cellname: "Epithelial cell",
    gene: "TGFB2",
  },
  {
    dataset_id: "LSE100106",
    p_val_adj: 0.0043,
    avg_log2_fc: -0.5714,
    cellname: "Secretory cell",
    gene: "TGFB2",
  },
  {
    dataset_id: "LSE100106",
    p_val_adj: 1,
    avg_log2_fc: -0.5664,
    cellname: "Ciliated cell",
    gene: "TGFB2",
  },
  {
    dataset_id: "LSE100106",
    p_val_adj: 1.7203e-38,
    avg_log2_fc: -0.5537,
    cellname: "Ciliated cell",
    gene: "TGFB2",
  },
  {
    dataset_id: "LSE100106",
    p_val_adj: 1.0676e-14,
    avg_log2_fc: -0.5436,
    cellname: "Erythrocyte",
    gene: "TGFB2",
  },
  {
    dataset_id: "LSE100106",
    p_val_adj: 1.9237e-22,
    avg_log2_fc: -0.5392,
    cellname: "Secretory cell",
    gene: "TGFB2",
  },
  {
    dataset_id: "LSE100106",
    p_val_adj: 0.0011,
    avg_log2_fc: -0.501,
    cellname: "Ciliated cell",
    gene: "TGFB2",
  },
  {
    dataset_id: "LSE100106",
    p_val_adj: 3.0914e-57,
    avg_log2_fc: 0.3885,
    cellname: "Airway smooth muscle cell",
    gene: "TGFB2",
  },
  {
    dataset_id: "LSE100106",
    p_val_adj: 2.5491e-12,
    avg_log2_fc: -0.3869,
    cellname: "Secretory cell",
    gene: "TGFB2",
  },
  {
    dataset_id: "LSE100106",
    p_val_adj: 1,
    avg_log2_fc: -0.384,
    cellname: "Neuroendocrine cell",
    gene: "TGFB2",
  },
  {
    dataset_id: "LSE100106",
    p_val_adj: 3.3431e-33,
    avg_log2_fc: 0.3186,
    cellname: "Epithelial cell",
    gene: "TGFB2",
  },
  {
    dataset_id: "LSE100106",
    p_val_adj: 1,
    avg_log2_fc: -0.2653,
    cellname: "Submucosal gland",
    gene: "TGFB2",
  },
  {
    dataset_id: "LSE100108",
    p_val_adj: 3.7193e-47,
    avg_log2_fc: -0.2829,
    cellname: "Ciliated cell",
    gene: "TGFB2",
  },
  {
    dataset_id: "LSE100108",
    p_val_adj: 0,
    avg_log2_fc: 0.2555,
    cellname: "Secretory cell",
    gene: "TGFB2",
  },
  {
    dataset_id: "LSE100108",
    p_val_adj: 7.1282e-162,
    avg_log2_fc: 0.2528,
    cellname: "Basal cell",
    gene: "TGFB2",
  },
  {
    dataset_id: "LSE100111",
    p_val_adj: 1.87e-111,
    avg_log2_fc: 0.2629,
    cellname: "Lymphatic endothelial cell",
    gene: "TGFB2",
  },
  {
    dataset_id: "LSE100112",
    p_val_adj: 2.0104e-49,
    avg_log2_fc: 0.5896,
    cellname: "Pericyte",
    gene: "TGFB2",
  },
  {
    dataset_id: "LSE100112",
    p_val_adj: 3.6219e-16,
    avg_log2_fc: 0.4464,
    cellname: "Vascular associated smooth muscle cell",
    gene: "TGFB2",
  },
  {
    dataset_id: "LSE100112",
    p_val_adj: 3.0772e-27,
    avg_log2_fc: 0.3632,
    cellname: "Myofibroblast",
    gene: "TGFB2",
  },
  {
    dataset_id: "LSE101112",
    p_val_adj: 2.0244e-17,
    avg_log2_fc: 0.7516,
    cellname: "Pericyte",
    gene: "TGFB2",
  },
  {
    dataset_id: "LSE101112",
    p_val_adj: 1.2677e-6,
    avg_log2_fc: 0.7396,
    cellname: "Pericyte",
    gene: "TGFB2",
  },
  {
    dataset_id: "LSE101112",
    p_val_adj: 7.8998e-8,
    avg_log2_fc: 0.3907,
    cellname: "Pericyte",
    gene: "TGFB2",
  },
  {
    dataset_id: "LSE100114",
    p_val_adj: 5.9353e-28,
    avg_log2_fc: 0.3021,
    cellname: "Dendritic cell",
    gene: "TGFB2",
  },
];
const data = this.tableData;
// 提取数据字段
const xData = Array.from(new Set(data.map((item :any) => item.cellType)));
let yData = data.map((item :any) => item.datasetId);
let yDataArr = Array.from(new Set(yData));

const colorData: number[] = Array.from(new Set(data.map((item :any) => (item.avgLog2Fc))));
//const pVal: number[] = Array.from(new Set(data.map((item :any) => (item.pvalAdj))));


const fixedRanges = [
  { min: 0.01, max: 1, label: '>0.01', color: '#999' },
  { min: 0.001, max: 0.01, label: '0.01~0.001', color: '#999' },
  { min: 0.0001, max: 0.001, label: '0.001~0.0001', color: '#999' },
  { min: 0.00001, max: 0.0001, label: '0.0001~0.00001', color: '#999' },
  { min: 0, max: 0.00001, label: '<0.00001', color: '#999' }
];

const getVisibleRanges = (data:any) => {
  const visibleRanges = [];

  for (const range of fixedRanges) {
    const rangeValues = data.filter((item:any) => item.pvalAdj >= range.min && item.pvalAdj <= range.max);
    
    if (rangeValues.length > 0) {
      visibleRanges.push(range);
    }
  }

  return visibleRanges;
};

const visibleRanges = getVisibleRanges(data);

// 配置气泡图选项
const option = {
  toolbox: {
    feature: {
      saveAsImage: {
        title: '保存为图片',
        pixelRatio: 2 // 设置保存图片的分辨率，默认为 1，可以根据需要调整
      },
      // 其他工具配置...
    }
  },
  backgroundColor: '#ffffff',
  
  grid: {
    containLabel: true,
    left: '2%',
    right: '20%',
    bottom: '10%',
    top: '10%'
  },
  xAxis: {
    type: 'category',
    data: xData,
    color: '#000000',
    axisLabel: {
      rotate: 45, // 设置标签旋转角度为45度
      interval: 0, // 强制显示所有标签
      fontSize: 12, // 设置 x 轴标签的字体大小
      fontWeight: 'bold', // 设置 x 轴标签的字体粗细
      fontStyle: 'oblique',
    }
  },
  yAxis: {
    type: 'category',
    data: yDataArr
  },
  visualMap: [
    {
      left: '79%',
      top: '10%',
      dimension: 2,
      itemWidth: 30,
      seriesIndex: 0,
      itemHeight: 120,
      precision: 4,
      text: ['Average Log2 Fold Change'],
      min: Math.min(...colorData),
      max: Math.max(...colorData),
      controller: {
    inRange: {
      onchange: function (params:any) {
        console.log("更新0");
        // 获取当前选中的范围
        const selectedRange = params.selected;

        // 根据选中范围更新横坐标数据
        const filteredXData = xData.filter((item, index) => {
          // 根据索引获取对应的平均值
          const avgLog2Fc = colorData[index];
          
          // 判断平均值是否在当前范围内，且该横坐标是否存在数据
          return (
            avgLog2Fc >= selectedRange[0] &&
            avgLog2Fc <= selectedRange[1] &&
            yDataArr.includes(item)
          );
        });

        // 更新图表横坐标数据
        console.log("更新1");
        option.xAxis.data = filteredXData;

        // 使用 updatedOption 更新图表配置
        myChart.setOption(option, true);
        console.log("更新2");
      },
    }
  },
      calculable: true,
      inRange: {
        color: ['#ffffd9','#edf8b1','#c7e9b4','#7fcdbb','#41b6c4','#1d91c0','#225ea8','#253494','#081d58']
      }
    },
    
    {
    type: 'piecewise',
    left: '80%',
    bottom: '10%',
    seriesIndex: 0,
    dimension: 3, // 数据数组的索引，对应 p_val_adj 数据
    //pieces: visualMapPieces,
    splitNumber: 5,
    pieces: visibleRanges,
    inRange: {
      symbol: 'circle',
       // 定义颜色范围，需要与 visualMapPieces 对应
    },
    outOfRange: {
      symbol: 'circle',
      color: ['#999'] // visualMap 区域外的颜色
    },
    textStyle: {
      color: '#000' // 文本颜色
    },
    //precision: 10, // 小数点精度
    itemHeight: 120
    }
  ],
  series: [
  {
    name: 'Average Log2 Fold Change',
    type: 'scatter',
    symbolSize: function (val: any) {
      //console.log(val)
      //console.log(/^-?\d+\.\d+$/.test(val[3]),Number(parseFloat(val[3]).toFixed(10)),Number(parseFloat(val[3]).toFixed(10)) *30);
      let fcVal = 20;
      let valp = Number(parseFloat(val[3]).toFixed(5));
      if(Number(parseFloat(val[3]).toFixed(2))>0.01){
        fcVal = 30;
      }else if(Number(parseFloat(val[3]).toFixed(2)) <= 0.01 && Number(parseFloat(val[3]).toFixed(3)) > 0.001 ){
        fcVal = 25;
      }
      else if(Number(parseFloat(val[3]).toFixed(3)) <= 0.001 && Number(parseFloat(val[3]).toFixed(4)) > 0.0001 ){
        fcVal = 20;
      }
      else if(Number(parseFloat(val[3]).toFixed(4)) <= 0.0001 && Number(parseFloat(val[3]).toFixed(5)) > 0.00001 ){
        fcVal = 15;
      }else{
        fcVal = 10;
      }
      return (fcVal); // 气泡大小
    },
    data: data.map((item: any )=> [item.cellType, item.datasetId, item.avgLog2Fc, item.pvalAdj]),

  }]
};


// 使用配置项绘制气泡图
myChart.setOption(option);
  },
  
}
});
